import { render, staticRenderFns } from "./BeServicesFiltersList.vue?vue&type=template&id=04c96388&scoped=true"
import script from "./BeServicesFiltersList.vue?vue&type=script&lang=js"
export * from "./BeServicesFiltersList.vue?vue&type=script&lang=js"
import style0 from "./BeServicesFiltersList.vue?vue&type=style&index=0&id=04c96388&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c96388",
  null
  
)

export default component.exports